import { render, staticRenderFns } from "./ChooseTenantTraderButton.vue?vue&type=template&id=a4240060&scoped=true&"
import script from "./ChooseTenantTraderButton.vue?vue&type=script&lang=js&"
export * from "./ChooseTenantTraderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4240060",
  null
  
)

export default component.exports